import { Dropdown, MenuItem } from '@components/dropdown';
import {
  IcoCheck,
  IcoCollection,
  IcoDocument,
  IcoFilter,
  IcoImage,
  IcoMusic,
  IcoVideoCamera,
} from '@components/icons';
import { FILTER_CONTROL_CLASS, filterControlState, filterIconState } from './filter-control';

export type FileCategory = 'image' | 'video' | 'audio' | 'document';
export type CategoryValue = 'all' | FileCategory;

const OPTIONS: Array<{ value: CategoryValue; label: string; icon: typeof IcoFilter }> = [
  { value: 'all', label: 'All file types', icon: IcoCollection },
  { value: 'image', label: 'Images', icon: IcoImage },
  { value: 'video', label: 'Videos', icon: IcoVideoCamera },
  { value: 'audio', label: 'Audio', icon: IcoMusic },
  { value: 'document', label: 'Documents', icon: IcoDocument },
];

type Props = {
  value: CategoryValue;
  onChange(value: CategoryValue): void;
};

export function CategoryFilter({ value, onChange }: Props) {
  const current = OPTIONS.find((o) => o.value === value) ?? OPTIONS[0];
  return (
    <Dropdown
      class="w-full min-w-0 sm:w-auto"
      fullWidth
      position="left-0 top-2"
      triggerClass={`${FILTER_CONTROL_CLASS} ${filterControlState(value !== 'all')} sm:max-w-72`}
      renderMenu={() => (
        <>
          {OPTIONS.map((opt) => (
            <MenuItem
              key={opt.value}
              regularCase
              isSelected={opt.value === value}
              onClick={() => onChange(opt.value)}
            >
              <opt.icon
                class={`size-4 shrink-0 ${opt.value === value ? 'text-indigo-600' : 'text-gray-400'}`}
              />
              <span class="flex-1">{opt.label}</span>
              {opt.value === value && <IcoCheck class="size-4 shrink-0 text-indigo-600" />}
            </MenuItem>
          ))}
        </>
      )}
    >
      <IcoFilter class={`size-4 shrink-0 ${filterIconState(value !== 'all')}`} />
      <span class="min-w-0 truncate whitespace-nowrap">{current.label}</span>
    </Dropdown>
  );
}

export function toCategoryParam(value: CategoryValue): FileCategory | undefined {
  return value === 'all' ? undefined : value;
}
